export default __webpack_public_path__ + "static/media/Masdar-Abu-Dhabi-Future-Energy.f141e280.png";